import React from 'react';
import { Create, SimpleForm } from 'react-admin';
import { Breadcrumbs, Container, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink, useSearchParams } from 'react-router';
import AppBarSaveActions from '../components/AppBarSaveActions.tsx';
import OpportunityProfileForm from './OpportunityProfileForm.tsx';

const OpportunityProfileCreate: React.FC = () => {
  const [searchParams] = useSearchParams();
  const opportunityIdParam = searchParams.get('opportunityId');
  const opportunityId = opportunityIdParam ? Number(opportunityIdParam) : undefined;

  return (
    <Container maxWidth="lg">
      <Breadcrumbs sx={{ mt: 2 }}>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/">
          Dashboard
        </MuiLink>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/opportunities">
          Opportunities
        </MuiLink>
        <Typography color="text.primary">Profile</Typography>
      </Breadcrumbs>
      <Create
        mutationMode="pessimistic"
        transform={(data) => {
          const dataWithoutId = { ...data };
          delete dataWithoutId.id;
          return dataWithoutId;
        }}
      >
        <SimpleForm
          defaultValues={opportunityId ? { opportunityId } : undefined}
          toolbar={<AppBarSaveActions showDelete={false} />}
        >
          <Container maxWidth="md">
            <Typography variant="h5" gutterBottom>
              Opportunity Profile
            </Typography>
            <OpportunityProfileForm />
          </Container>
        </SimpleForm>
      </Create>
    </Container>
  );
};

export default OpportunityProfileCreate;
